module.exports = __webpack_public_path__ + "static/media/weight-scale-2402966_640_color.d522d033.png";